import { Data } from "./parseKeytoColumn";

export const shoterNames = (data: Data[]) => {
  return data.map((i) => {
    const maxLength = 20;
    const key = Object.keys(i)[0];
    const value = i[key];

    if (typeof value !== "string") return { ...i };

    let formatted = value
      .split(" ")
      .slice(0, 2)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");

    if (formatted.length > maxLength) {
      formatted = formatted.slice(0, maxLength - 1) + "…";
    }
    return {
      ...i,
      [key]: formatted,
    };
  });
};